import { Module } from "vuex";
import { getters } from "./getters";
import { actions } from "./actions";
import { mutations } from "./mutations";
import { AuthenticationState, CurrentUser, JwtConfigs } from "./types";
import { RootState } from "@/store/types";

export const state: AuthenticationState = {
    currentUser: <CurrentUser>{
        id: "",
        username: "",
        languageCode: "en",
        firstName: "",
        lastName: "",
        isRegularUser: true,
        roles: [] as string[]
    },
    token: "",
    tokenValidTo: null,
    jwtConfigs: <JwtConfigs>{
        jwtExpireSeconds: 0,
        jwtInvalidSeconds: 0,
        jwtLogoutWarningSeconds: 0
    },
    autoLogout: false
};

const namespaced: boolean = true;

export const authentication: Module<AuthenticationState, RootState> = {
    namespaced,
    state,
    getters,
    actions,
    mutations
};
